import { useState } from 'react';
import type { RSVPFormData, RSVPApiResponse } from '@shared/types';
import { submitRSVP } from '../utils/api';

interface UseRSVPReturn {
  submit: (data: RSVPFormData) => Promise<RSVPApiResponse>;
  isLoading: boolean;
  error: string | null;
  success: boolean;
}

export function useRSVP(): UseRSVPReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const submit = async (data: RSVPFormData): Promise<RSVPApiResponse> => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const result = await submitRSVP(data);

      if (result.success) {
        setSuccess(true);
      } else {
        setError(result.message);
      }

      return result;
    } catch (err) {
      const errorMessage = 'Failed to submit RSVP. Please try again.';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    submit,
    isLoading,
    error,
    success,
  };
}
